var createStylesheet = (chunkId, fullhref, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;

	(function(linkTag) {
	                if (typeof _N_E_STYLE_LOAD === 'function') {
	                    const { href, onload, onerror } = linkTag;
	                    _N_E_STYLE_LOAD(href.indexOf(window.location.origin) === 0 ? new URL(href).pathname : href).then(()=>onload == null ? void 0 : onload.call(linkTag, {
	                            type: 'load'
	                        }), ()=>onerror == null ? void 0 : onerror.call(linkTag, {}));
	                } else {
	                    document.head.appendChild(linkTag);
	                }
	            })(linkTag)
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	8068: 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"4":1,"144":1,"166":1,"173":1,"266":1,"408":1,"424":1,"462":1,"530":1,"602":1,"795":1,"829":1,"901":1,"948":1,"955":1,"1003":1,"1038":1,"1289":1,"1314":1,"1382":1,"1482":1,"1588":1,"1604":1,"1610":1,"1630":1,"1694":1,"1796":1,"1805":1,"1851":1,"1998":1,"2152":1,"2160":1,"2266":1,"2321":1,"2343":1,"2393":1,"2414":1,"2426":1,"2455":1,"2674":1,"2708":1,"2719":1,"2726":1,"2804":1,"2808":1,"2915":1,"3034":1,"3101":1,"3151":1,"3166":1,"3194":1,"3213":1,"3246":1,"3258":1,"3268":1,"3390":1,"3504":1,"3571":1,"3654":1,"3658":1,"3680":1,"3751":1,"3774":1,"4063":1,"4106":1,"4144":1,"4148":1,"4170":1,"4384":1,"4592":1,"4629":1,"4774":1,"4927":1,"5033":1,"5205":1,"5237":1,"5503":1,"5575":1,"5588":1,"5620":1,"5632":1,"5766":1,"5776":1,"5786":1,"5972":1,"5992":1,"6049":1,"6073":1,"6170":1,"6336":1,"6356":1,"6395":1,"6410":1,"6441":1,"6486":1,"6576":1,"6741":1,"6754":1,"6801":1,"6906":1,"7039":1,"7132":1,"7165":1,"7223":1,"7227":1,"7344":1,"7451":1,"7482":1,"7618":1,"7732":1,"7834":1,"7927":1,"8028":1,"8228":1,"8302":1,"8410":1,"8682":1,"8746":1,"8778":1,"8860":1,"8888":1,"8993":1,"9148":1,"9282":1,"9318":1,"9330":1,"9450":1,"9641":1,"9676":1,"9705":1,"9842":1,"9889":1,"9896":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr